import { getMappedEvents } from '../utils/getMappedEvents';

// События для shared экрана и модалки шаринга
const EVENTS = [
  'sharePageShown',
  'discoverPlanClick',
  'loginClick',
  'tryItFreeClick',
  'shareModalShown',
  'shareCopyLinkClick',
] as const;

export const trialShareEvents = getMappedEvents([...EVENTS], {
  shouldSendSubscriptionData: true,
});